import { defineMessages } from 'react-intl';

const messages = defineMessages({
  filter_bando: {
    id: 'search-prj-filter_bando',
    defaultMessage: 'Bando',
  },
  filter_veste_giuridica: {
    id: 'search-prj-filter_veste_giuridica',
    defaultMessage: 'Veste giuridica',
  },
  filter_provincia: {
    id: 'search-prj-filter_provincia',
    defaultMessage: 'Provincia',
  },
  filter_tipologie_intervento: {
    id: 'search-prj-filter_tipologie_intervento',
    defaultMessage: 'Tipologia di attività/intervento',
  },
  filter_organizzazione: {
    id: 'search-prj-filter_organizzazione',
    defaultMessage: 'Organizzazione',
  },
  filter_contributo: {
    id: 'search-prj-filter_contributo',
    defaultMessage: 'Contributo Fondazione Cariplo',
  },
  filter_partner: {
    id: 'search-prj-filter_partner',
    defaultMessage: 'Partner',
  },
  filter_date: {
    id: 'search-prj-filter_date',
    defaultMessage: 'Data',
  },
  filter_anno: {
    id: 'search-prj-filter_anno',
    defaultMessage: 'Anno',
  },
  filter_budget: {
    id: 'search-prj-filter_budget',
    defaultMessage: 'Budget progetto',
  },
  filter_contributo_fc: {
    id: 'search-prj-contributo_fc',
    defaultMessage: 'Contributo Fondazione Cariplo',
  },
  filter_subject: {
    id: 'search-prj-subject',
    defaultMessage: 'Parole chiave',
  },
  reset_filters: {
    id: 'search-prj-reset_filters',
    defaultMessage: 'Reset filtri',
  },
  in_progress: {
    id: 'search-prj-filter_in_progress',
    defaultMessage: 'Progetti in corso',
  },
  search: {
    id: 'search-prj-search',
    defaultMessage: 'Cerca progetti',
  },
  sort_on: { id: 'search-prj-sort', defaultMessage: 'Ordina per' },
  sort_data_avvio: {
    id: 'search-prj-sort_data_avvio',
    defaultMessage: 'Data di avvio',
  },
});
export default messages;
